
const State = {
    user: null,
    authenticated: false,
    token: null,
    property_owners: null,
    property_managers: null,
    residents: null,
    user_count: null,
    managers_count: null
};

export default State;
